import { render, staticRenderFns } from "./TifTramasExport.vue?vue&type=template&id=2dd61601"
import script from "./TifTramasExport.vue?vue&type=script&lang=js"
export * from "./TifTramasExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports